module.exports = __webpack_public_path__ + "assets/models/exit_button.glb";